import request from '@/utils/request';
import store from '../store'
// 溯源批次管理

// 批次管理---批次数据导出
export function exportExcel(params){
    return request({
        url:'/batch/exportExcel',
        method:'post',
        data:{
            batchIds:params
        }
    })
}

export function list(params) {
    // 根据 商户ID 查询列表(如果是 admin 用户 则可以查看所有的 1 是admin)
    let {routers,merchantId} = store.getters
    if(routers.length<14){
        params.merchantId = merchantId
    }else{
        params.merchantId=""
    }
    return request({
        url: '/Base/com.trace.model.BizProductBatchBean/list',
        method: 'get',
        params: params
    })
}

export function queryList(data) {
    // if(merchantId)
    return request({
        url: '/batch/list',
        method: 'post',
        data: data,
        headers:{
            "content-type": "application/json"
        }
    })
}


export function save(data,type) {
    let merchantId = store.getters.merchantId
    let postData=JSON.parse(data)
    postData.merchantId = merchantId
    return request({
        url: `/trace/traceBatchSave?type=${type}`,
        method: 'post',
        data: JSON.stringify(postData),
        headers:{
            "content-type": "application/json"
        }
    })
}

// 修改以已上链批次的可补充上链的接口
export function updateIsAdd(data){
    return request({
        url:'/trace/updateIsAdd',
        method:'post',
        data:data
    })
}




export function deleteById(data) {
    return request({
        url: '/trace/deleteTraceBatch',
        method: 'post',
        data: data,
        headers:{
            "content-type": "application/x-www-form-urlencoded"
        }
    })
}

export function commit(data) {
    return request({
        url: '/trace/commit',
        method: 'post',
        data: data,
        headers:{
            "content-type": "application/x-www-form-urlencoded"
        }
    })
}

export function update(data) {
    return request({
        url: '/trace/update',
        method: 'post',
        data: data,
        headers:{
            "content-type": "application/x-www-form-urlencoded"
        }
    })
}

export function syncIns(data) {
    return request({
        url: '/trace/sync',
        method: 'post',
        data: data,
        headers:{
            "content-type": "application/x-www-form-urlencoded"
        }
    })
}

export function syncCheck(data) {
    return request({
        url: '/trace/syncCheck',
        method: 'post',
        data: data,
        headers:{
            "content-type": "application/x-www-form-urlencoded"
        }
    })
}

export function importProductBatch(data) {
    return request({
        url: '/product/importProductBatch',
        method: 'post',
        data: data,
    })
}

export function getSonMerchantIds(data) {
    return request({
        url: '/merchant/getSonIds',
        method: 'post',
        data: data,
    })
}

export function pass(data) {
    return request({
        url: '/batch/pass',
        method: 'post',
        data: data,
        headers:{
            "content-type": "application/x-www-form-urlencoded"
        }
    })
}

export function passtype(data) {
    return request({
        url:'/batch/passType',
        method:'post',
        data:data,
        headers:{
            "content-type": "application/x-www-form-urlencoded"
        }
    })
}

/* 
流水号接口
*/

export function serialList(batchId,page,limit){
    return request({
        url:'/code/findCollect',
        method:'get',
        params:{
            batchId,
            page,
            limit
        }
    })
}

export function serialInfo(batchId,sumId,page,limit){
    return request({
        url:'/code/findList',
        method:'get',
        params:{
            batchId,
            sumId,
            page,
            limit
        }
    })
}

export function makeSerial(data){
    return request({
        url:'/code/createCode',
        method:'post',
        data:data
    })
}

export function excelImport(sumId){
    return request({
        url:'/code/exportCode',
        method:'get',
        params:{
            sumId
        }
    })
}




// WEBPACK FOOTER //
// ./src/api/traceBatch.js